import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import SelectField from 'shared/components/formFields/select-field';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import { GatewayType } from 'features/gateway/domain/models/gateway-type';
import useGatewayValidation from 'features/gateway/hooks/gateway-validation-hook';

const GatewaySettingsType = () => {
  const { t } = useTranslation('gateway');

  const { validateSingularityOfMediaServerGateway } = useGatewayValidation();

  const {
    formState: { errors },
    control,
  } = useFormContext();
  const registerOptions = {
    type: {
      required: t('details.information.requiredHelperText'),
      validate: validateSingularityOfMediaServerGateway,
    },
  };

  const { gatewayDetailsHook } = useGatewaysContextProvider();

  const isCreating = gatewayDetailsHook.viewingMode === 'creation';
  const availableOptions = Object.values(GatewayType)
    .filter((gatewayType) => gatewayType !== GatewayType.Unknown && !(isCreating && gatewayType === GatewayType.IoTEdge))
    .sort((a, b) => a.localeCompare(b));

  if (isCreating) {
    return (
      <Controller
        name="type"
        control={control}
        rules={registerOptions.type}
        render={({ field }) => {
          return (
            <SelectField
              {...field}
              inputProps={{ 'data-testid': 'typeInput' }}
              id="typeInput"
              error={!!errors.type}
              helperText={errors.type?.message?.toString()}
              variant="outlined"
              label={t('details.settings.typeLabel')}
              value={field.value ?? ''}
            >
              {availableOptions.map((gatewayType) => (
                <MenuItem data-testid={`gateway-type-${gatewayType}`} key={`gatewayType-${gatewayType}`} value={gatewayType}>
                  {t(`details.settings.type.${gatewayType}`)}
                </MenuItem>
              ))}
            </SelectField>
          );
        }}
      />
    );
  }

  return (
    <>
      <Typography variant="h5">{t('details.settings.typeLabel')}</Typography>
      <Typography variant="subtitle1" data-testid="gatewaySettingsType">
        {t(`details.settings.type.${gatewayDetailsHook.currentSelectedGateway?.type}`)}
      </Typography>
    </>
  );
};

export default GatewaySettingsType;
